export default {
    t: {
        placeholderA:'チャンネルを選択してください...',
        btn:'アップロード',
        title: 'ヘッドライン',
        desc: '簡単な紹介',
        upload: 'アップロードするファイル',
        other: 'その他',
        Channel: 'チャネル',
        Source: '出典'
    },
    c: {
        a: "目を引く見出しは必ず必要不可欠です。 ",
        b: "簡潔な紹介文の場合は、短ければ短いほど良いです。なぜ、どのようにして、どのようにして、ということを150語以内で簡潔に説明できれば十分でしょう。",
        c:{
            0:'動画と写真のどちらか一方を選択して投稿してください。',
            1:'動画と写真の両方が投稿された場合は、動画ファイルが先に再生されます。',
            2:'ビデオの最大サイズは30M以下とします。そしてフォーマットはMP4、HD1080 (H.264、1920x1080; AAC、320Kbps、ステレオ)でなければなりません。',
            3:'映像は 1500*1500、300dpi の最大サイズの JPG/JPEG/PNG のフォーマットになければなりません。そして 5~8 枚の映像は大きく、十分である。'
        },
        d: {
            0:'概念設計：例：火星のホームランド - 概念設計の段階では、プロトタイプ製品はなく、実現可能性調査のためのデモのみが行われている。',
            1:'プロトタイプ設計：例：Muskの火星探査機 - 概念設計を超えており、規模の商業化に向けてコンセプトを検証するためのテストが行われている。',
            2:'革新的なデザイン：例：SawStop - 既存の商業化された製品に革新的な改良を加え、本来の機能や追加機能をより良く発揮できるようにしたもの。',
            3:'製品デザイン：例：ROYOLE Flexible Screen - これまでに類似製品がなく、コンセプト、プロトタイプ段階を完了し、商業化されています。',
            4:'革新的な方法: 例: 革新的な水素製造プロセス - 製品を入手または製造するために全く新しい方法を使用しています。',
            5:'革新的な材料：例：DCLAN-全く新しい材料を入手、製造、または合成するための方法または公式。'

        },
        e:"オリジナリティを尊重します。盗作は犯罪です。そのため、必ず引用元を明記してください。また、リンクは共有するコンテンツと一致していなければなりません。"
  },

}